import { ZoomInOutlined } from '@ant-design/icons';
import type Map from 'ol/Map';
import { type RefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ZoomControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.colorBgContainer};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colorBorder};
  padding: 4px 12px;
`;

interface Props {
  map: RefObject<Map | null>;
}

/** Indicatore del livello di zoom corrente nella barra controlli mappa. */
export function MapZoomIndicator(props: Props) {
  const { map } = props;
  const { t } = useTranslation();
  const [zoom, setZoom] = useState<number | null>(null);

  useEffect(() => {
    if (!map.current) return;

    const view = map.current.getView();
    const update = () => setZoom(Math.round((view.getZoom() ?? 0) * 10) / 10);

    update();
    view.on('change:resolution', update);
    return () => view.un('change:resolution', update);
  }, [map]);

  if (zoom == null) return null;

  return (
    <ZoomControl>
      <span>
        <ZoomInOutlined />
      </span>
      <span>{t('map-widget.zoom-level', 'Zoom: {{zoom}}', { zoom })}</span>
    </ZoomControl>
  );
}
